export const FETCH_TEAMS_REQUEST = 'integrations/linear/FETCH_TEAMS_REQUEST'
export const FETCH_TEAMS_SUCCESS = 'integrations/linear/FETCH_TEAMS_SUCCESS'
export const FETCH_TEAMS_FAILURE = 'integrations/linear/FETCH_TEAMS_FAILURE'

export const FETCH_WORKFLOW_STATES_REQUEST =
  'integrations/linear/FETCH_WORKFLOW_STATES_REQUEST'
export const FETCH_WORKFLOW_STATES_SUCCESS =
  'integrations/linear/FETCH_WORKFLOW_STATES_SUCCESS'
export const FETCH_WORKFLOW_STATES_FAILURE =
  'integrations/linear/FETCH_WORKFLOW_STATES_FAILURE'

export const FETCH_ISSUE_REQUEST = 'integrations/linear/FETCH_ISSUE_REQUEST'
export const FETCH_ISSUE_SUCCESS = 'integrations/linear/FETCH_ISSUE_SUCCESS'
export const FETCH_ISSUE_FAILURE = 'integrations/linear/FETCH_ISSUE_FAILURE'

export const CREATE_ISSUE_REQUEST = 'integrations/linear/CREATE_ISSUE_REQUEST'
export const CREATE_ISSUE_SUCCESS = 'integrations/linear/CREATE_ISSUE_SUCCESS'
export const CREATE_ISSUE_FAILURE = 'integrations/linear/CREATE_ISSUE_FAILURE'
